module.exports = __webpack_public_path__ + "img/noprizeXF.b3dde66d.png";